import { render, staticRenderFns } from "./_more_col.vue?vue&type=template&id=74b55970&"
import script from "./_more_col.vue?vue&type=script&lang=js&"
export * from "./_more_col.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports